import { useApiRequest } from '~/hooks/api';
import { useStoreActions, useStoreState } from '~/store/hooks';
import extractFullName from '~/utils/text/extractFullName';

import { IUseGetEditClientAllocationsParams, IUseGetEditClientAllocationsResult } from '../types';
import AllocationTypes from '../../../constants/allocationTypes';
import useFeature from '~/store/clinic/hooks/useFeature';

const useGetEditClientAllocationsForGlobalUser = ({
  clientAllocationDate,
  enabled = true,
}: IUseGetEditClientAllocationsParams): IUseGetEditClientAllocationsResult => {
  const {
    clinic: userClinic,
    id: userId,
    photo,
    ...user
  } = useStoreState(state => state.user.current);

  const onGetMyClinic = useStoreActions(actions => actions.clinic.onGetMyClinic);
  const { onGetActTeamsAvailable } = useStoreActions(actions => actions.actTeam);
  const { onGetOwnClientAllocationGU, onGetAllocationClientsByGroupGU } = useStoreActions(
    actions => actions.clientAllocation,
  );
  const clientAllocations = useStoreState(state => state.clientAllocation.current) || [];
  const { isCrisisAvailable } = useFeature();
  const userFullName = extractFullName(user);

  const { isLoading, refetch } = useApiRequest(
    async () => {
      const clinicId = String(userClinic.id);
      const allocationDate = `${clientAllocationDate}T00:00:00Z`;

      await onGetMyClinic();
      await onGetActTeamsAvailable({ clinicId });

      await onGetOwnClientAllocationGU({
        clientAllocationDate: allocationDate,
        allocationType: isCrisisAvailable ? AllocationTypes.ALL : AllocationTypes.STANDARD,
      });

      await onGetAllocationClientsByGroupGU({ clinicId });
    },
    {
      enabled,
      dependencies: [clientAllocationDate, userClinic.id, userId, userFullName, photo],
    },
  );

  return {
    isLoading,
    teamMembers: [{ id: userId, fullName: userFullName, photo, isDeleted: false }],
    allocations: clientAllocations,
    clients: [], // Client list we is getting in useGetClientsGU hooks and ClientMultiSelect component
    refetch,
  };
};

export default useGetEditClientAllocationsForGlobalUser;
